import axios, { getData } from "lib/axios"

export const getDepartment = async () => {
    return await axios.get(`/admin/suborganisation`).then(getData)
}

export const getLeavePolicies = async () => {
    return await axios.get(`/admin/leave-policy-dropdown`).then(getData)
}

export const getStaffList = async (params) => {
    return await axios.get(`/admin/staff`, { params }).then(getData)
}

export const generateMonthlyReport = async (data) => {
    return await axios.post(`/admin/leave/department-leave-report`, data, { responseType: 'blob' })
}

export const generateIndividualReport = async (staffId, data) => {
    return await axios.post(`/admin/leave/staff/${staffId}/staff-leave-report`, data, { responseType: 'blob' })
}